"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_UNITS_WITH_SERIES = exports._BUSINESS_UNITS_WITH_SERIES = exports.BUSINESS_UNITS_ID_SHORTNAME_MAP = exports.USED_BUSINESS_UNITS = exports.BUSINESS_UNITS = void 0;
const time_1 = require("../time");
// Any changes have to be reflected in eapi-ee-gateway:auth0/rules/Map_ADFS_Groups_to_Roles.js:4
const _BUSINESS_UNITS = {
    CIE: {
        id: '02',
        fullName: 'Cambridge Assessment International Education',
        name: 'Cambridge International',
        shortName: 'CIE',
    },
    OCR: {
        shortName: 'OCR',
        id: '01',
        fullName: 'OCR',
        name: 'OCR',
    },
    EFL: {
        shortName: 'EFL',
        id: '07',
        fullName: 'Cambridge Assessment English',
        name: 'Cambridge English',
    },
};
_BUSINESS_UNITS.CI = Object.assign(Object.assign({}, _BUSINESS_UNITS.CIE), { shortName: 'CI' });
_BUSINESS_UNITS.CE = Object.assign(Object.assign({}, _BUSINESS_UNITS.EFL), { shortName: 'CE' });
exports.BUSINESS_UNITS = _BUSINESS_UNITS;
exports.USED_BUSINESS_UNITS = [exports.BUSINESS_UNITS.CIE, exports.BUSINESS_UNITS.OCR];
exports.BUSINESS_UNITS_ID_SHORTNAME_MAP = {
    [exports.BUSINESS_UNITS.OCR.id]: exports.BUSINESS_UNITS.OCR.shortName,
    [exports.BUSINESS_UNITS.CIE.id]: exports.BUSINESS_UNITS.CIE.shortName,
};
exports._BUSINESS_UNITS_WITH_SERIES = {
    EFL: Object.assign(Object.assign({}, exports.BUSINESS_UNITS.EFL), { submissionWindows: {} }),
    CIE: Object.assign(Object.assign({}, exports.BUSINESS_UNITS.CIE), { submissionWindows: {
            3: [time_1.Month.FEBRUARY],
            6: [time_1.Month.APRIL, time_1.Month.MAY],
            11: [time_1.Month.OCTOBER],
        } }),
    OCR: Object.assign(Object.assign({}, exports.BUSINESS_UNITS.OCR), { submissionWindows: {
            1: [time_1.Month.DECEMBER],
            6: [time_1.Month.FEBRUARY],
            11: [time_1.Month.OCTOBER],
        } }),
};
exports._BUSINESS_UNITS_WITH_SERIES.CI = exports._BUSINESS_UNITS_WITH_SERIES.CIE;
exports._BUSINESS_UNITS_WITH_SERIES.CE = exports._BUSINESS_UNITS_WITH_SERIES.EFL;
exports.BUSINESS_UNITS_WITH_SERIES = exports._BUSINESS_UNITS_WITH_SERIES;
